import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { alpha, Box } from "@kaltura/mediaspace-shared-styled";
import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";

interface StyledDragAndDropIllustrationProps {
    width?: number;
    height?: number;
}

export const StyledDragAndDropIllustration = ({ width = 301, height = 300 }: StyledDragAndDropIllustrationProps) => {
    return (
        <StyledIllustration
            fileName={"Upload.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 301 300"
        >
            <rect x="35.5" y="191" width="189" height="53" rx="8" className="Primary" fill="#006EFA" />
            <path
                d="M93.3082 176.073C88.3074 177.012 83.3619 178.198 78.5095 179.758C72.6109 181.656 66.778 184.165 62.1175 188.26C57.4566 192.355 54.0723 198.242 54.1206 204.458C54.1747 211.456 58.5779 217.886 64.2924 221.899C70.007 225.913 76.9028 227.848 83.7447 229.213C100.206 232.496 117.083 232.862 133.829 233.99C150.575 235.117 167.513 237.076 183.1 243.321C198.687 249.566 212.964 260.587 220.05 275.853"
                className="sTone1"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M90.8359 76.3184C90.8359 71.9001 94.4177 68.3184 98.8359 68.3184H240.5C244.918 68.3184 248.5 71.9001 248.5 76.3184V163.318L265.646 207.082C267.702 212.329 263.833 218 258.197 218H102.847C98.692 218 95.2287 214.82 94.8756 210.68L90.8359 163.318L90.8359 76.3184Z"
                className="Tone1"
                fill="#333333"
            />
            <rect x="99.5" y="76.5" width="140" height="84" rx="8" className="Tone8" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M128.407 178.018C128.152 175.653 130.005 173.59 132.384 173.59H217.394C219.256 173.59 220.871 174.874 221.291 176.688L224.995 192.688C225.576 195.195 223.672 197.59 221.098 197.59H134.107C132.063 197.59 130.348 196.05 130.13 194.018L128.407 178.018Z"
                className="sTone8"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M165.5 102C165.5 97.5817 169.082 94 173.5 94H197.5C201.918 94 205.5 97.5817 205.5 102V126C205.5 130.418 201.918 134 197.5 134H173.5C169.082 134 165.5 130.418 165.5 126V102Z"
                className="Tone1"
                fill="#333333"
            />
            <rect
                x="142.5"
                y="123"
                width="33"
                height="28"
                rx="8"
                className="Tone8 sTone1"
                fill="white"
                stroke="#333333"
                strokeWidth="2"
            />
            <path
                d="M148.5 138.806C150.026 137.245 151.715 135.62 154.057 135.038C154.23 134.995 154.445 134.967 154.567 135.075C154.628 135.128 154.649 135.203 154.665 135.274C154.896 136.319 154.397 137.391 154.528 138.447C154.536 138.511 154.55 138.581 154.61 138.624C154.706 138.69 154.852 138.649 154.964 138.601C155.791 138.246 156.501 137.722 157.35 137.403C158.199 137.084 159.301 137.016 159.989 137.533C160.425 137.861 160.618 138.368 161.074 138.678C161.478 138.952 162.038 139.031 162.561 138.99C163.084 138.949 163.583 138.801 164.081 138.663C166.152 138.092 168.437 137.694 170.5 138.286"
                className="sTone1"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <rect x="133.5" y="47" width="55" height="62" rx="8" className="Primary" fill="#006EFA" />
            <path d="M160.808 97V59" className="sTone8" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <path
                d="M146.5 74L160.904 59L175.5 74"
                className="sTone8"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.0001 146C48.0001 146 47.2111 144.908 46.1005 142.929C46.1134 142.976 46.1199 143 46.1199 143C46.1199 143 38.213 141.447 34.1408 134.818C31.6302 130.731 30.2804 125.282 30.0916 118.471C30.0762 117.916 30.0762 116.859 31.5825 117.803C35.2104 120.079 38.2046 124.356 40.5134 128.749C38.9151 122.237 38.2394 114.319 40.262 105.776C40.5085 105 40.8273 104.621 41.5663 105.53C47.9591 113.393 51.0002 122.518 51.0002 132.378C51.0002 132.378 53.6864 115.871 65.8175 108.489C66.5475 108.045 68.183 107.165 68.183 109.503C68.183 119.169 65.9464 126.833 61.5392 132.873C64.9526 130.82 69.5894 129.146 76.3381 128.917C76.8586 128.9 78.0508 128.9 76.8861 130.101C69.9166 137.286 62.7676 142.823 54.1935 146.159C54.1935 146.159 52.215 144.353 52.5161 141.985C46.7288 147.27 48.0001 146 48.0001 146Z"
                className="Tone1"
                fill="#333333"
            />
            <rect x="30.5002" y="141" width="41" height="30" rx="8" className="Primary" fill="#006EFA" />
            <mask
                id="mask0_73399_87742"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="30"
                y="141"
                width="42"
                height="30"
            >
                <rect x="30.5002" y="141" width="41" height="30" rx="8" fill="white" />
            </mask>
            <g mask="url(#mask0_73399_87742)">
                <path d="M30.5002 148.5H71.5002" className="sTone8" stroke="white" strokeWidth="2" />
                <path d="M30.5002 155.5H71.5002" className="sTone8" stroke="white" strokeWidth="2" />
                <path d="M30.5002 162.5H71.5002" className="sTone8" stroke="white" strokeWidth="2" />
            </g>
        </StyledIllustration>
    );
};

export const StyledDragAndDropIllustration200 = ({ width = 200, height = 200 }: StyledDragAndDropIllustrationProps) => {
    return (
        <StyledIllustration
            fileName={"Upload.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 200 200"
        >
            <rect x="23.3335" y="127.334" width="126" height="35.3333" rx="4" className="Primary" fill="#006EFA" />
            <path
                d="M61.8723 117.381C58.5384 118.007 55.2415 118.798 52.0065 119.838C48.0741 121.103 44.1855 122.776 41.0785 125.506C37.9712 128.236 35.715 132.161 35.7473 136.304C35.7833 140.97 38.7187 145.256 42.5284 147.932C46.3381 150.608 50.9354 151.898 55.4966 152.808C66.4711 154.997 77.722 155.24 88.8862 155.992C100.05 156.744 111.342 158.05 121.733 162.213C132.125 166.377 141.643 173.724 146.367 183.901"
                className="sTone1"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.2241 50.8783C60.2241 47.9327 62.6119 45.5449 65.5575 45.5449H160C162.946 45.5449 165.333 47.9327 165.333 50.8783V108.878L176.764 138.054C178.135 141.552 175.555 145.333 171.798 145.333H68.2313C65.4615 145.333 63.1526 143.212 62.9173 140.453L60.2241 108.878L60.2241 50.8783Z"
                className="Tone1"
                fill="#333333"
            />
            <rect x="66" y="51" width="93.3333" height="56" rx="4" className="Tone8" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M85.192 117.941C85.0647 116.758 85.9912 115.727 87.1805 115.727H145.126C146.057 115.727 146.865 116.369 147.075 117.275L149.853 129.275C150.143 130.529 149.191 131.727 147.904 131.727H88.4725C87.4508 131.727 86.5934 130.956 86.484 129.941L85.192 117.941Z"
                className="sTone8"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M110 66.666C110 64.4569 111.791 62.666 114 62.666H132.667C134.876 62.666 136.667 64.4569 136.667 66.666V85.3327C136.667 87.5418 134.876 89.3327 132.667 89.3327H114C111.791 89.3327 110 87.5418 110 85.3327V66.666Z"
                className="Tone1"
                fill="#333333"
            />
            <rect
                x="94.6665"
                y="82"
                width="22"
                height="18.6667"
                rx="4"
                className="Tone8 sTone1"
                fill="white"
                stroke="#333333"
                strokeWidth="2"
            />
            <path
                d="M98.6665 92.5374C99.6837 91.4967 100.81 90.4132 102.371 90.0255C102.486 89.9969 102.63 89.978 102.711 90.05C102.752 90.0855 102.766 90.1353 102.776 90.1829C102.93 90.8795 102.598 91.5938 102.685 92.298C102.691 92.3408 102.7 92.3876 102.74 92.4157C102.804 92.4603 102.901 92.4323 102.976 92.4005C103.527 92.1641 104 91.8148 104.566 91.6019C105.132 91.389 105.867 91.344 106.326 91.6887C106.616 91.9076 106.745 92.2453 107.05 92.4518C107.319 92.6344 107.692 92.6872 108.04 92.66C108.389 92.6327 108.722 92.5339 109.054 92.4423C110.435 92.0612 111.958 91.7961 113.333 92.1906"
                className="sTone1"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <rect x="88.6665" y="31.334" width="36.6667" height="41.3333" rx="4" className="Primary" fill="#006EFA" />
            <path d="M106.872 64.6673V39.334" className="sTone8" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <path
                d="M97.3335 49.334L106.936 39.334L116.667 49.334"
                className="sTone8"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.5081 70.5174C26.6725 69.9999 26.8846 69.7473 27.3773 70.3533C31.639 75.5956 33.6663 81.6786 33.6663 88.2518C33.6767 88.1887 35.4811 77.2331 43.5452 72.326C44.032 72.0298 45.1224 71.4436 45.1224 73.0018C45.1224 79.4474 43.6295 84.5577 40.6898 88.5848C42.9657 87.2151 46.0576 86.098 50.5589 85.9451C50.906 85.9334 51.7005 85.9338 50.9242 86.7342C46.2779 91.5247 41.5112 95.2155 35.7952 97.4393C35.7728 97.4186 34.4751 96.2196 34.6771 94.6522C30.8291 98.1664 31.661 97.3382 31.6663 97.3328C31.6524 97.3135 31.1297 96.5849 30.3978 95.2801C30.4067 95.3125 30.4127 95.3302 30.4134 95.3328C30.4134 95.3328 25.1419 94.298 22.4271 89.8787C20.7534 87.1542 19.8538 83.5214 19.7279 78.9803C19.7176 78.6109 19.7178 77.906 20.722 78.536C23.1439 80.0554 25.14 82.9138 26.68 85.8465C25.6119 81.5025 25.1583 76.2186 26.5081 70.5174Z"
                className="Tone1"
                fill="#333333"
            />
            <rect x="20" y="94" width="27.3333" height="20" rx="5.33333" className="Primary" fill="#006EFA" />
            <mask
                id="mask0_63773_12272"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="20"
                y="94"
                width="28"
                height="20"
            >
                <rect x="20" y="94" width="27.3333" height="20" rx="4" fill="white" />
            </mask>
            <g mask="url(#mask0_63773_12272)">
                <path d="M20 98.9993H47.3333" className="sTone8" stroke="white" strokeWidth="1.5" />
                <path d="M20 103.667H47.3333" className="sTone8" stroke="white" strokeWidth="1.5" />
                <path d="M20 108.333H47.3333" className="sTone8" stroke="white" strokeWidth="1.5" />
            </g>
        </StyledIllustration>
    );
};
export const StyledHiddenInput = styled("input")({
    visibility: "hidden",
    display: "none",
});

export const StyledText = styled(Typography)(({ theme }) => ({
    marginTop: theme.typography.pxToRem(8),
    marginBottom: theme.typography.pxToRem(16),
    maxWidth: "100%",
}));

export const StyledBox = styled(
    Box,
    {
        shouldForwardProp: (prop) => {
            return !["withColor", "fullSize"].includes(prop.toString());
        },
    }
)<{ withColor: boolean; fullSize: boolean }>(({ theme, withColor, fullSize }) => ({
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",

    height: theme.typography.pxToRem(200),
    [theme.breakpoints.down("sm")]: {
        height: "unset",
    },
    padding: theme.typography.pxToRem(40),
    paddingTop: theme.typography.pxToRem(32),
    marginBottom: theme.typography.pxToRem(16),

    ...(
        fullSize && {
            height: "unset",
            padding: theme.typography.pxToRem(80),
            paddingTop: theme.typography.pxToRem(80), // override the non-fullsize rule
            marginBottom: theme.typography.pxToRem(60),
        }
    ),

    borderRadius: theme.kaltura.shape.roundness1,
    borderColor: theme.kaltura.palette.tone4,
    ...(
        withColor && {
            backgroundColor: alpha(theme.kaltura.palette.primary.main, 0.08),
            borderColor: theme.kaltura.palette.primary.main,
        }
    ),

    borderStyle: "dashed",
    borderWidth: 2,
    cursor: "grab",
    [`&:active`]: {
        cursor: "grabbing",
    },
}));
